import styled, { css } from "styled-components/macro";

import { isTouchscreenDevice } from "../../lib/isTouchscreenDevice";

export default styled.div`
    height: 100%;
    display: flex;
    user-select: none;
    flex-direction: row;
    align-items: stretch;

    background-color: rgba(
        var(--background-rgb),
        max(var(--min-opacity), 0.75)
    );
    backdrop-filter: blur(20px);
`;

export const RIGHT_SIDEBAR_WIDTH = 425;
export const LEFT_SIDEBAR_WIDTH = 232;

export const GenericSidebarBase = styled.div<{
    mobilePadding?: boolean;
    right?: boolean;
}>`
    height: 100%;

    ${(props) =>
        props.right
            ? css`
                  width: 100%;
              `
            : css`
                  width: ${LEFT_SIDEBAR_WIDTH}px;
              `}
    display: flex;
    flex-shrink: 0;
    flex-direction: column;
    background: var(--secondary-background);

    ${(props) =>
        props.mobilePadding &&
        isTouchscreenDevice &&
        css`
            padding-bottom: 50px;
        `}
`;

export const GenericSidebarList = styled.div`
    padding: 6px;
    flex-grow: 1;
    overflow-y: scroll;

    > img {
        width: 100%;
    }
`;
